export default "__VITE_PUBLIC_ASSET__082558c6__"